const resources = {
    seeDetails: 'Voir les détails'
};

module.exports = function getResource(label) {
    return resources[label];
};
